import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { GroupService } from "../../models/group.service";
import { RoundTimeService } from "../../round-time/round-time.service";

@Component({
  selector: "ab-error-cards",
  templateUrl: "./error-cards.component.html",
})
export class ErrorCardsComponent implements OnChanges, OnInit {
  @Input() public project: any;
  @Input() public routeStats: any;
  @Input() public timeDurAgo: any;
  @Input() public dur: string;
  public loading: boolean;
  public startTime: number;
  public groups: any;
  public unresolvedGroupCount: any;
  public resolvedGroupCount: any;
  public noticeCount: any;

  constructor(
    private groupService: GroupService,
    private roundTimeService: RoundTimeService,
  ) {}

  public ngOnInit() {
    this.groups = [];
    this.unresolvedGroupCount = 0;
    this.resolvedGroupCount = 0;
    this.noticeCount = 0;
  }

  public ngOnChanges() {
    if (!this.routeStats || !this.timeDurAgo) {
      return;
    }

    this.startTime = Math.round(new Date(this.timeDurAgo).getTime() / 1000);
    this.fetchGroups();
  }

  private fetchGroups() {
    this.loading = true;

    this.groupService
      .query({
        projectId: this.project.id,
        "context.httpMethod": this.routeStats.method,
        "context.route": this.routeStats.route,
        "context.environment": this.routeStats.env,
        time__gte: this.roundTimeService.timestampFor(
          this.timeDurAgo,
          this.dur,
        ),
        limit: 100,
      })
      .pipe(
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe((data: any) => {
        this.groups = data;

        this.noticeCount = 0;
        for (const group of data.groups) {
          this.noticeCount += group.noticeFilterCount;
        }

        this.unresolvedGroupCount = data.groups.filter(
          (g: any) => !g.resolved,
        ).length;
        this.resolvedGroupCount = data.groups.filter(
          (g: any) => g.resolved,
        ).length;
      });
  }
}
